export const defaultTheme = {
  borders: {
    none: 'none',
    thinSolid: '1px solid',
    normalSolid: '2px solid',
    largeSolid: '3px solid',
    xLargeSolid: '4px solid',
    thinDashed: '1px dashad',
    normalDashed: '2px dashed',
    largeDashed: '3px dashed',
    xLargeDashed: '4px dashed'
  },
  borderStyles: {
    solid: 'solid',
    dashed: 'dashed'
  },
  borderWidths: {
    thin: '1px',
    normal: '2px',
    large: '3px',
    xLarge: '4px'
  },
  breakpoints: {
    get: () => 481
  },
  colors: {
    getColor: () => '',
    transparent: 'transparent',
    white: '#fff',
    black: '#000',
    text: '#737680',
    primary: '#004186',
    secondary: '#DF8D2C',
    tertiary: '#CD4D9A',
    blue: {
      dark: '#004186',
      normal: '#75BFBA',
      light: '#91D8F6'
    },
    green: {
      light: '#C7DC7A',
      dark: '#8AA15C'
    },
    yellow: '#FECA30',
    beige: '#D6CCB2',
    salmon: '#E8936F',
    pink: '#CD4D9A',
    lilac: '#C43B51',
    gray: {
      dark: '#4F4F4F',
      medium: '#828282',
      normal: '#BDBDBD',
      light: '#E0E0E0',
      lightBg: '#F2F2F2',
      extra: '#C9CDDA'
    },
    gradient: {
      footer:
        'linear-gradient(180deg, #004186 0%, rgba(145, 216, 246, 0.19) 100%), linear-gradient(348.37deg, #91D8F6 6.69%, rgba(145, 216, 246, 0.2) 69.09%), #004186',
      iconsBg:
        'linear-gradient (90deg, #FFFFFF 57.24%, rgba(255, 255, 255, 0) 100%), #F2F2F2',
      hero: 'linear-gradient (270deg, #F2F2F2 28.09%, #FFFBFF 45.22%, rgba (255, 251, 255, 0) 48.17%), linear-gradient (90deg, #F5F6F8 50%, rgba (245, 246, 248, 0) 64.88%)'
    },
    rgba: {
      yellow: 'rgba(254, 202, 48, 0.25)',
      lilac: 'rgba(196, 59, 81, 0.25)',
      green: 'rgba(199, 220, 122, 0.25)',
      primary: 'rgb(0, 65, 134, 0.25)'
    }
  },
  fonts: {
    body: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    getWeights: () => ({
      black: '',
      bold: '',
      light: '',
      medium: '',
      regular: '',
      thin: ''
    }),
    monospace:
      'SFMono-Regular, Menlo, Monaco,Consolas, "Liberation Mono", "Courier New", monospace'
  },
  fontSizes: {
    base: '14px',
    xxs: '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2rem',
    '5xl': '2.25rem',
    '6xl': '3rem',
    '7xl': '4rem'
  },
  fontWeights: {
    light: 300,
    regular: 400,
    semibold: 500,
    bold: 700,
    black: 900
  },
  lineHeights: {
    small: 1.3,
    normal: 1.4,
    large: 1.5
  },
  letterSpacings: {
    small: -0.6,
    large: 0.45
  },
  shadows: {
    none: 'none',
    sm: '0px 2px 4px rgba(0, 0, 0, 0.16)',
    md: '0px 10px 20px rgba(0, 0, 0, 0.08)',
    lg: '0px 10px 40px rgba(0, 0, 0, 0.16)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
  },
  radii: {
    none: '0',
    default: '4px',
    small: '2px',
    normal: '4px',
    large: '6px',
    xLarge: '8px',
    rounded: '100px'
  },
  space: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem'
  },
  speeds: {
    slow: '380ms',
    normal: '240ms',
    fast: '160ms'
  }
}

export type LegacyTheme = typeof defaultTheme
